export default __webpack_public_path__ + "static/playdough-202898ce3592993554b9f5e488c87a2a.png";